import React, { useEffect, useState } from "react";
import { Container, Button, Form, Modal } from "react-bootstrap";
import "../../../assets/css/Settings/Billing/PaymentMethodsRadioButton.css";
import NewPaymentMethodModal from "./NewPaymentMethodModal";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/css/loadingwrapper.css";
import {
  stripeCustomerAllPaymentMethodsData,
  stripeCustomerData,
} from "../../../Redux/Stripe/action";
const PaymentMethods = () => {
  const dispatch = useDispatch();
  const paymentData = useSelector((state) => state.authReducer.paymentData);
  const [paymentMethods, setPaymentMethods] = useState();
  const [currentPackageId, setCurrentPackageId] = useState();
  const [defaultPaymentId, setDefaultPaymentId] = useState();
  const [showAddForm, setShowAddForm] = useState(false);
  const [newPaymentMethod, setNewPaymentMethod] = useState({
    card: {
      brand: "",
      last4: "",
      exp_month: 1,
      exp_year: 2023,
    },
  });
  const [customerDetails, setCustomerDetails] = useState();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [subscriptionError, setSubscriptionError] = useState(null);
  const [confirmationText, setConfirmationText] = useState("");
  const customerPaymentMethodsByIdSuccess = useSelector(
    (state) => state.stripeReducer.customerPaymentMethodsByIdSuccess,
  );
  const customerByIdSuccess = useSelector(
    (state) => state.stripeReducer.customerByIdSuccess,
  );
  useEffect(() => {
    if (paymentData) {
      const fetchData = async () => {
        try {
          await stripeCustomerAllPaymentMethodsData(
            dispatch,
            paymentData?.customerID,
          );
          await stripeCustomerData(dispatch, paymentData?.customerID);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
  }, [paymentData]);

  useEffect(() => {
    if (customerPaymentMethodsByIdSuccess) {
      setPaymentMethods(customerPaymentMethodsByIdSuccess);
    }
  }, [customerPaymentMethodsByIdSuccess]);

  useEffect(() => {
    if (customerByIdSuccess) {
      setCustomerDetails(customerByIdSuccess);
      setCurrentPackageId(
        customerByIdSuccess?.invoice_settings?.default_payment_method,
      );
      setDefaultPaymentId(
        customerByIdSuccess?.invoice_settings?.default_payment_method,
      );
    }
  }, [customerByIdSuccess]);

  const monthAbbreviations = [
    "",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const getMonthAbbreviation = (month) => {
    return monthAbbreviations[month];
  };
  const handleRadioChange = (id) => {
    // setCurrentPackageId(id);
  };
  const handleChangeDefault = () => {
    setDefaultPaymentId(currentPackageId);
  };
  const handleCancelChange = () => {
    setCurrentPackageId(defaultPaymentId);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPaymentMethod({
      ...newPaymentMethod,
      card: {
        ...newPaymentMethod.card,
        [name]: value,
      },
    });
  };

  const handleShowAddForm = () => {
    setShowAddForm(true);
  };

  const handleCancelAddForm = () => {
    setShowAddForm(false);
  };
  const handleChangePlan = () => {
    setShowConfirmationModal(true);
  };

  const handleCloseConfirmationModal = () => {
    setShowConfirmationModal(false);
    setSubscriptionError(null);
    setConfirmationText("");
  };
  const isConfirmationTextValid = confirmationText === "Delete";
  const showProceedButton = confirmationText && isConfirmationTextValid;

  const handleConfirmation = async () => {
    try {
      if (confirmationText.toLowerCase() === "delete") {
        // REMOVE Payment Method
        // const paymentMethod = await stripe.paymentMethods.detach('${currentPackageId}');

        setConfirmationText("");
        setShowConfirmationModal(false);
        // setShowSuccessAnimation(true);
      }
    } catch (error) {
      setSubscriptionError("Error updating subscription. Please try again. ");
    }
  };
  return (
    <Container>
      <div className={"main-h4-tag-large"}>
        <p>Payment Details</p>
      </div>
      {paymentMethods?.data?.length > 0 ? (
        <>
          <div>
            {paymentMethods?.data?.map((data) => (
              <div key={data.id} className="d-flex justify-content-between">
                <div className={"d-flex align-items-center"}>
                  <input
                    className="input"
                    type="radio"
                    name="radio"
                    checked={data.id === currentPackageId}
                    onChange={() => handleRadioChange(data.id)}
                  />
                  <span className="custom-bold-text ml-1">
                    {data.card?.brand.charAt(0).toUpperCase() +
                      data.card?.brand.slice(1)}{" "}
                  </span>
                  <span className="custom-bold-text custom-enlarged-dots">
                    ....{" "}
                  </span>
                  <span className="custom-bold-text">{data.card?.last4} </span>
                  {data.id === currentPackageId ? (
                    <span className="custom-default-text">Default</span>
                  ) : null}
                </div>
                <div className={"d-flex align-items-center"}>
                  <span
                    className={
                      "custom-expire-card-text d-flex justify-content-start mr-3"
                    }
                  >
                    Expires {getMonthAbbreviation(data.card?.exp_month)}{" "}
                    {data.card?.exp_year}
                  </span>
                  <button className="bin-button" onClick={handleChangePlan}>
                    <svg
                      className="bin-top"
                      viewBox="0 0 39 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ width: "19.5px", height: "3.5px" }}
                    >
                      <line
                        y1="5"
                        x1="9"
                        x2="29"
                        y2="5"
                        stroke="white"
                        strokeWidth="3"
                      ></line>
                      <line
                        x1="14"
                        y1="2.5"
                        x2="24"
                        y2="2.5"
                        stroke="white"
                        strokeWidth="3"
                      ></line>
                    </svg>
                    <svg
                      className="bin-bottom"
                      viewBox="0 0 33 39"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ width: "8.25px", height: "9.75px" }}
                    >
                      <mask id="path-1-inside-1_8_19" fill="white">
                        <path d="M0 0H33V35C33 37.2091 31.2091 39 29 39H4C1.79086 39 0 37.2091 0 35V0Z"></path>
                      </mask>
                      <path
                        d="M0 0H33H0ZM37 35C37 39.4183 33.4183 43 29 43H4C-0.418278 43 -4 39.4183 -4 35H4H29H37ZM4 43C-0.418278 43 -4 39.4183 -4 35V0H4V35V43ZM37 0V35C37 39.4183 33.4183 43 29 43V35V0H37Z"
                        fill="white"
                        mask="url(#path-1-inside-1_8_19)"
                      ></path>
                      <path
                        d="M12 6L12 29"
                        stroke="white"
                        strokeWidth="4"
                      ></path>
                      <path d="M21 6V29" stroke="white" strokeWidth="4"></path>
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className="loader">
            <div className="wrapper">
              <div className="circle"></div>
              <div className="line-1"></div>
              <div className="line-2"></div>
              <div className="line-3"></div>
              <div className="line-4"></div>
              <div className="line-5"></div>
            </div>
          </div>
        </>
      )}
      {showAddForm ? (
        <Modal show={showAddForm} onHide={handleCancelAddForm}>
          <Modal.Header closeButton>
            <Modal.Title className={"main-h4-tag-large mt-3"}>
              Add New Payment Method
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <NewPaymentMethodModal />
            </Form>
          </Modal.Body>
        </Modal>
      ) : (
        <div
          className="p-md-3 border mt-2"
          style={{ backgroundColor: "#f6f7f7", borderRadius: "8%" }}
        >
          <p
            style={{
              fontSize: "13px",
              fontWeight: "bolder",
              color: "#172e57",
              marginBottom: "auto",
              cursor: "pointer",
            }}
            className={"d-flex justify-content-center"}
            onClick={handleShowAddForm}
          >
            + Add New Payment Method
          </p>
        </div>
      )}
      {currentPackageId !== defaultPaymentId && (
        <div className="d-flex justify-content-end mt-1">
          <Button
            variant="danger"
            size="sm"
            style={{ backgroundColor: "red" }}
            onClick={handleCancelChange}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            style={{ backgroundColor: "#172e57" }}
            onClick={handleChangeDefault}
          >
            Change Default
          </Button>
        </div>
      )}
      {/* Confirmation Modal */}
      <Modal
        centered
        backdrop="static"
        show={showConfirmationModal}
        onHide={handleCloseConfirmationModal}
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#172e57", color: "white" }}
        >
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f8f9fa" }}>
          <Form.Group controlId="confirmationText">
            <Form.Label style={{ fontWeight: "bold", color: "#172e57" }}>
              Please type "Delete" to Remove the Card
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Type here"
              value={confirmationText}
              onChange={(e) => setConfirmationText(e.target.value)}
              style={{ border: "1px solid #ced4da" }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#f8f9fa" }}>
          {subscriptionError && (
            <div
              style={{ color: "red", fontSize: "small", margin: "auto" }}
              className={"w-50 p-0"}
            >
              {subscriptionError}
            </div>
          )}
          <div>
            <Button
              variant="secondary"
              onClick={handleCloseConfirmationModal}
              style={{ backgroundColor: "#6c757d", borderColor: "#6c757d" }}
            >
              Close
            </Button>
            {showProceedButton && (
              <Button
                variant="primary"
                onClick={handleConfirmation}
                style={{ backgroundColor: "#172e57", borderColor: "#172e57" }}
              >
                Proceed
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default PaymentMethods;
